import React from 'react';

import { ReactComponent as ExternalLinkSvg } from '@assets/icons/external_link.svg';
import { useNavigate } from 'react-router-dom';
import useAppDispatch from '@data/useAppDispatch';
import { logoutUser } from '@data/app/app.thunk';
import NavItem from '../../nav-item/NavItem';
import HDivider from '../../../../../components/divider/HDivider';

const MenuFooter: React.FC<{ className?: string }> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [logoutLoading, setLogoutLoading] = React.useState(false);

  const onLogout = React.useCallback(
    () => () => {
      if (!logoutLoading) {
        setLogoutLoading(true);
        dispatch(logoutUser())
          .then(() => {
            navigate('/');
          })
          .finally(() => {
            setLogoutLoading(false);
          });
      }
    },
    [dispatch, navigate, logoutLoading, setLogoutLoading],
  );

  return (
    <div className="w-full lg:w-auto lg:fixed lg:bottom-0 flex-col-center  pb-3.5">
      <HDivider className="ml-6 mr-6 mt-3.5" />
      <NavItem
        key="Log out"
        label="Log out"
        pathname="out"
        icon={ExternalLinkSvg}
        onClick={onLogout()}
      />
    </div>
  );
};

export default MenuFooter;
